// extracted by mini-css-extract-plugin
export default {"title":"TA2EW7N9","mobile":"mobile","envelope":"waH6UC5D","money":"PXvOamic"};